import { render, staticRenderFns } from "./couponBusinessConfList.vue?vue&type=template&id=43874360&scoped=true"
import script from "./couponBusinessConfList?vue&type=script&lang=js&external"
export * from "./couponBusinessConfList?vue&type=script&lang=js&external"
import style0 from "./couponBusinessConfList.vue?vue&type=style&index=0&id=43874360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43874360",
  null
  
)

export default component.exports